<template>
	<div id="energyLeftBottom">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">楼层用能</span>
				</div>
			</div>
			<div style="width: 100%;" class="d-flex jc-center">
				<div id="energyLeftBottomChart" style="width: 95%; height: 5.2rem;"></div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	import echarts from "echarts"
	export default {
		components: {

		},
		data() {
			return {
				chart: null,
			};
		},
		props: ['energyLeftBottomData'],
		watch: {
			'energyLeftBottomData': {
				handler() {
					this.draw();
				},
			},
			deep: true
		},
		mounted() {
			this.draw();
		},
		methods: {
			draw() {
				// 基于准备好的dom，初始化echarts实例
				this.chart = this.$echarts.init(
					document.getElementById("energyLeftBottomChart"), 'dark'
				);
				let nameList = [];
				let valueList = [];
				for (let item of this.energyLeftBottomData) {
					nameList.push(item.name)
					valueList.push(item.value)
				}

				let option = {
					backgroundColor: 'rgb(255,255,255,0)', //背景色
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
					},
					grid: {
						left: '5%',
						right: '10%',
						top: '5%',
						bottom: '5%',
						containLabel: true
					},
					// dataZoom: [{
					// 		type: 'slider',
					// 		show: false,
					// 		yAxisIndex: [0],
					// 		right: '0',
					// 		start: 1,
					// 		end: 50,
					// 	},
					// 	{
					// 		type: 'inside',
					// 		yAxisIndex: [0],
					// 		start: 1,
					// 		end: 50
					// 	}
					// ],
					xAxis: {
						type: 'value',
						name: '单位：度',
						nameLocation: 'start',
						splitLine: {
							show: false
						},
						nameTextStyle: {
							verticalAlign: 'top'
						},
						axisLabel: {
							formatter: function(value) {
								if (value >= 1000) {
									value = value / 1000 + "k";
								} else if (value < 1000) {
									value;
								}
								return value;
							},
							textStyle: {
								color: '#fff',
							}
						},
					},
					yAxis: {
						type: 'category',
						data: nameList,
						inverse: true,
						splitLine: {
							show: false
						},
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						nameTextStyle: {
							fontSize: 15
						},
						axisLabel: {
							formatter: function(value, index) {
								if (index == 0) {
									return "{top|TOP1}" + '  ' + value;
								} else if (index == 1) {
									return "{top|TOP2}" + '  ' + value;
								} else if (index == 2) {
									return "{top|TOP3}" + '  ' + value;
								} else {
									return value;
								}
							},
							textStyle: {
								color: '#fff',
							},
							rich: {
								top: {
									borderColor: '#00B4D8',
									fontSize: 13,
									borderWidth: 1,
									padding: 5,
									fontWeight: 'bold',
								},
							}
						},
					},
					series: [{
						name: '用能（KWH）',
						type: 'bar',
						data: valueList,
						barWidth: 14,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(255, 255, 255, 1)',
						},
						barGap: 10,
						smooth: true,
						label: {
							normal: {
								show: true,
								position: 'right',
								textStyle: {
									color: '#fff',
									fontSize: 13
								},
							},
						},
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
									offset: 0,
									color: "#1FE5E6"
								}, {
									offset: 1,
									color: "#3E97CF"
								}], false)
							}
						}
					}]
				};

				this.chart.setOption(option);
			},
		},

		destroyed() {
			window.onresize = null;
		},
	};
</script>

<style lang="scss">
	#energyLeftBottom {
		height: 5.6rem;
		width: 7.75rem;
	}
</style>
